import * as React from "react";
import { BrowserRouter, Route, Link, Switch, Redirect, withRouter } from "react-router-dom";
import AuthService from '../../services/authService';
import { connect } from 'react-redux';
import * as Constants from '../../common/constants';
import * as actionTypes from '../../store/actionTypes';

interface IProps {
  onUserLogout: any,
  history: any
}

interface IState {
}

class NotAuthenticatedComponent extends React.Component<IProps, IState> {
  аuthService = new AuthService();

  componentDidMount() {
    if (!this.аuthService.isAuthenticated()) {
      this.props.onUserLogout();
      this.props.history.push(`/login?returnUrl=${window.location.pathname}`);
    }
  }

  public render() {
    return (
      <div className="app-content">
        <h2>You are not Authenticated to view this page.</h2>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onUserLogout: () => dispatch({ type: actionTypes.USER_LOGOUT })
  }
}

export default withRouter(connect(null, mapDispatchToProps)(NotAuthenticatedComponent));